import { extend, ExtendOptionsInit } from 'umi-request';
import qs from 'qs';
import { setElkScope } from '@/utils/elkReport';

interface RequestOptions extends ExtendOptionsInit {
  fileName?: string;
  checkResponse?: boolean;
  showError?: boolean | string;
  showSuccess?: boolean | string;
}

export interface ResponseType {
  data?: any;
  message?: string;
  status: number;
}

export enum STATUS {
  FAIL = 0, // 操作失败
  SUCCESS = 1, // 成功
  NOT_LOGIN = 305, // 用户未登录
  NOT_FOUND = 404, // 数据不存在
  NOT_ALLOWED = 405, // 没有权限操作
  STATUS_ERROR = 412, // 状态错误
  PARAM_ERROR = 414, // 参数错误
  DATA_FOUND = 417, // 数据已存在
  UNKNOWN_ERROR = 500, // 未知错误
}

export interface HeadersMap {
  deviceType?: string;
  appVersion?: string;
  deviceId?: string;
  Authorization?: string;
}

const queryObj = qs.parse(window.location.search.replace(/^\?/, ''));

const headersMap = {};

const queryHeaders = {
  deviceType: queryObj.deviceType,
  appVersion: queryObj.appVersion,
  deviceId: queryObj.deviceId,
  'x-vmeeting-source': queryObj.source,
};

// 设置客户端接口header
export function setClientHeaders(headers: HeadersMap) {
  const hm: HeadersMap = {};
  Object.keys(headers).forEach(key => {
    if (headers[key]) {
      hm[key] = headers[key];
    }
  });
  Object.assign(headersMap, hm);
  try {
    setElkScope({
      meetingId: queryObj.meetingId,
      ...queryHeaders,
    });
  } catch (err) {
    console.log(err);
  }
}
setClientHeaders(queryHeaders);

/**
 * 自定义request
 */
const clientAjax = extend({});

clientAjax.interceptors.request.use((url, params) => {
  // const token = getHeaderToken();
  const meetingId = window.location.pathname.match(/\/meet\/(\d{6,9})/)?.[1] || '';
  const { body, params: customParams = {}, ...options } = params;
  const { checkResponse = true } = customParams as any;
  let { headers } = options;
  headers = {
    ...headersMap,
    ...headers,
  };
  if (meetingId) {
    // @ts-ignore
    headers.meetingId = meetingId;
  }

  if (body) {
    options.data = body;
  }

  return {
    url,
    options: { ...options, headers, checkResponse, interceptors: true, params: customParams },
  };
});

/**
 * 自定义response拦截器
 */
clientAjax.interceptors.response.use(async (response: Response, options: RequestOptions) => {
  const { checkResponse, showError = true, showSuccess } = options;
  const { responseType = 'json' } = options;

  if (checkResponse && responseType === 'json') {
    const jsonData = (await response.clone()[responseType]()) as ResponseType;
    const { message, status, data } = jsonData;

    if (status === STATUS.SUCCESS) {
      // 请求成功
      if (showSuccess) {
        // Message.success(message || '操作成功');
      }
    } else {
      // 请求失败
      if (status === STATUS.NOT_LOGIN) {
        // authLogin();
      } else if ([STATUS.NOT_FOUND, STATUS.NOT_ALLOWED].includes(status)) {
        // 数据不存在/没有权限操作，进行路由调整处理
        // history.push('/404');
      } else if (showError) {
        // Message.error(message || '操作失败');
      }

      throw jsonData;
    }
  } else {
    // 部分第三方接口返回格式与一般格式不同，另行校验
    const { status } = response;

    if (status !== 200) {
      // Message.error('操作失败');
      throw response;
    }
  }

  return response;
});

export default clientAjax;
